import * as S from './styles';
import Switch from '@components/Common/Switch';
import InfoLineIcon from '@svgIcons/info_line.svg';
import SortIcon from '@svgIcons/sorting.svg';
import PanelOptionMixin from '../../mixin';

export default {
    name: 'SortToggle',
    mixins: [PanelOptionMixin],
    props: {
        sortAlphabetically: {
            type: Boolean,
            default: false,
        },
        handleUpdateSortAlphabetically: {
            type: Function,
            default: () => {},
        },
    },
    render() {
        const { sortAlphabetically, handleUpdateSortAlphabetically } = this;

        return (
            <S.ComponentWrapper>
                <div class="top-wrapper">
                    <div class="title">
                        <SortIcon class="sort-icon" fill="#2A333D" />
                        <h3>{this.$t('NEW_DASHBOARD.sort_a_to_z')}</h3>
                        {this.wrapTooltip({
                            visible: true,
                            content: (
                                <InfoLineIcon
                                    class="info-line-icon"
                                    v-view-box
                                    fill="#949AA1"
                                />
                            ),
                            title: this.$t('NEW_DASHBOARD.sort_toggle_tooltip'),
                        })}
                    </div>
                    <Switch
                        value={sortAlphabetically}
                        type="big"
                        onClick={() =>
                            handleUpdateSortAlphabetically(!sortAlphabetically)
                        }
                    />
                </div>
            </S.ComponentWrapper>
        );
    },
};
